import { useLocation } from "react-router-dom";
import { Hammer } from "lucide-react";
import { OVERLINE, H1 } from "@/components/admin/ui";

const TITLES = {
  "/admin/subscriptions": ["Commerce", "Subscriptions"],
  "/admin/advertising": ["Commerce", "Advertising"],
  "/admin/businesses": ["Network", "Businesses"],
  "/admin/approvals": ["Network", "Approvals"],
  "/admin/guides": ["Network", "Guides & Outfitters"],
  "/admin/states": ["Network", "State Partnerships"],
  "/admin/marketplace": ["Content", "Marketplace"],
  "/admin/hunts": ["Content", "Hunts"],
  "/admin/content": ["Content", "Content & Recipes"],
  "/admin/website": ["Content", "Website / Homepage"],
  "/admin/analytics": ["Insights", "Analytics"],
  "/admin/reports": ["Insights", "Reports"],
  "/admin/users": ["Operations", "Users"],
  "/admin/support": ["Operations", "Support"],
  "/admin/notifications": ["Operations", "Notifications"],
};

export default function AdminPlaceholder() {
  const { pathname } = useLocation();
  const [group, title] = TITLES[pathname] || ["Admin", "Section"];
  return (
    <div className="p-6 md:p-8" data-testid="admin-placeholder">
      <span className={OVERLINE}>{group}</span>
      <h1 className={`${H1} mt-1`}>{title}</h1>
      <div className="mt-8 flex min-h-[360px] flex-col items-center justify-center border border-dashed border-[#E5E2DC] bg-white text-center px-6">
        <Hammer size={40} className="text-[#E5E2DC]" />
        <h2 className="text-lg font-serif text-[#1F2A22] mt-4">Building next</h2>
        <p className="text-sm text-[#5C6B61] mt-1 max-w-sm">The <strong>{title}</strong> module is part of an upcoming phase of the HomeRange Admin Portal. The secure foundation, owner dashboard, sales and revenue are live now.</p>
      </div>
    </div>
  );
}
